export const ButtonColor = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  TRANSPARENT: "transparent",
  NEUTRAL: "neutral",
};

export const ButtonSize = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
};

export const ButtonState = {
  ENABLED: "enabled",
  DISABLED: "disabled",
};

export const ButtonIcon = {
  SHOW: true,
  HIDE: false,
};
